import { MUTATION_KEYS, createMutationDefaults } from '@/shared/api';
import { issuePresignedUrl } from './api';

declare module '@/shared/api/react-query/mutation-client' {
  // 기존 MutationRegistry 인터페이스에 merge: 의존성 주입
  export interface MutationRegistry {
    [MUTATION_KEYS.ISSUE_PRESIGNED_URL]: {
      data: Awaited<ReturnType<typeof issuePresignedUrl>>;
      variables: { count: number };
    };
  }
}

createMutationDefaults([MUTATION_KEYS.ISSUE_PRESIGNED_URL], {
  mutationFn: ({ count }: { count: number }) => issuePresignedUrl(count),
  onSuccess: (data) => {
    return data;
  },
});
